export default defineNuxtRouteMiddleware(async () => {
    const { getToken } = useUser()
    const { $i18n } = useNuxtApp()
    const { URL_LOGIN_PAGE } = useAppConfig()
    const token = await getToken()

    if (!token) {
        return navigateTo(`/${$i18n.locale.value}${URL_LOGIN_PAGE}`)
    }
})
